import React, { useState } from "react";

// Images

import newPasswordImage from "../../assets/images/New-password.svg";
import lockImage from "../../assets/images/lock.svg";
import checkImage from "../../assets/images/check.svg";
//
import { useFormik } from "formik";
import { Button, Form, Modal } from "react-bootstrap";
import * as Yup from "yup";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import AuthService from "../../services/AuthService";
import { useTranslation } from "react-i18next";
import LogoImg from "../../assets/images/Main-Logo.png";
import { toast } from "react-toastify";
import HelmetBase from "../../components/HelmetBase";

const NewPassword = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const paramValue = searchParams.get("email");

  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleClose = () => setShow(false);

  const formValidations = Yup.object({
    password: Yup.string()
      .min(8, t("Password must be atleast 8 characters"))
      .required(t("Password is required")),
    confirmPassword: Yup.string()
      .required(t("Confirm password required"))
      .oneOf([Yup.ref("password"), null], t("Passwords must match")),
  });

  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    onSubmit: (values, { setSubmitting, resetForm }) => {
      let data = {
        ...values,
        email: paramValue,
      };
      setLoading(true);
      AuthService.resetPassword(data)
        .then((res) => {
          if (res.data.status == 1) {
            setLoading(false);
            setShow(true);
            resetForm();
            setSubmitting(false);
            // navigate(`/login`);
            toast.success(res?.data?.message);
          } else {
            setLoading(false);
            resetForm();
            setSubmitting(false);
            toast.warning(res?.data?.message);
          }
        })
        .catch((err) => {
          console.log("ERROR", err);
          setLoading(false);
          setSubmitting(false);
        });
    },
    validationSchema: formValidations,
  });

  const goSignUp = () => {
    navigate("/login");
    setShow(false);
  };

  return (
    <>
      <HelmetBase
        title={`${t("Reset Password")}`}
        name={`${t("Reset Password")}`}
      />
      <div className="container-fluid">
        <div className="row login-container">
          <div className="col-md-6 left-side">
            <img
              src={newPasswordImage}
              alt="Login Illustration"
              className="login-image"
            />
          </div>

          <div className="col-md-6 right-side">
            <div className="login-form">
              <div className="brand-logo d-flex justify-content-center mb-5">
                <Link to="/">
                  <img src={LogoImg} alt="" />
                </Link>
              </div>
              <div className="head-contant">
                <div className="head-image">
                  <img src={lockImage} alt="" />
                </div>
                <div className="head-text">
                  <h1>{t("New Password")}</h1>
                  <p>
                    {t(
                      "Almost there! Create a new password for your Offary account to keep it secure. Remember to choose a strong and unique password."
                    )}
                  </p>
                </div>
              </div>
              <Form onSubmit={formik.handleSubmit}>
                <div className="mb-3" style={{ position: "relative" }}>
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    placeholder={t("New Password")}
                    name="password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  <Button
                    variant="link"
                    className="show-hide-btn"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <i className="fa fa-eye"></i>
                    ) : (
                      <i className="fa fa-eye-slash"></i>
                    )}
                  </Button>
                  {formik.touched.password && formik.errors.password && (
                    <div className="text-danger">{formik.errors.password}</div>
                  )}
                </div>
                <div className="mb-2" style={{ position: "relative" }}>
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    className="form-control"
                    placeholder={t("Confirm new password")}
                    name="confirmPassword"
                    value={formik.values.confirmPassword}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  <Button
                    variant="link"
                    className="show-hide-btn"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? (
                      <i className="fa fa-eye"></i>
                    ) : (
                      <i className="fa fa-eye-slash"></i>
                    )}
                  </Button>
                  {formik.touched.confirmPassword &&
                    formik.errors.confirmPassword && (
                      <div className="text-danger">
                        {formik.errors.confirmPassword}
                      </div>
                    )}
                </div>

                <button
                  type="submit"
                  className="btn btn-primary w-100 mt-2"
                  disabled={loading ? true : false}
                >
                  {!loading ? `${t("Save Password")}` : `${t("Loading...")}`}
                </button>
              </Form>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        size="md"
        backdrop="static"
        centered
      >
        <Modal.Body>
          <div className="modal-icon">
            <img src={checkImage} alt="" />
          </div>
          <h2>{t("You’re all set!")}</h2>
          <p>{t("Your password has been successfully changed.")}</p>
          <Button variant="primary" onClick={() => goSignUp()}>
            {t("Go To Sign in page")}
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default NewPassword;

{
  /* <div id="successModal" className="modal" style="display: none;">
<div className="modal-content">
  <div className="modal-icon">
    <img src="images/check.svg" alt="" />
  </div>
  <h2>You’re all set!</h2>
  <p>Your password has been successfully changed.</p>
  <a href="login.html" className="btn btn-primary">Go To Sign In Page</a>
</div>
</div> */
}
